import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_ENDPOINTS } from "@/api/services/attendanceManagement/apiEndPoint";
import { baseQueryWithInterceptor } from "@/utils/customBaseQuery";
import { baseApi } from "@/utils/baseApi";

export const shiftRosterImportListApi = baseApi.injectEndpoints({

    endpoints: (builder) => ({
        getDateTypeSample: builder.query({
            query: () => ({
                url: API_ENDPOINTS.SHIFT_ROSTER_IMPORT.GET_DATE_TYPE_SAMPLE(),
                responseHandler: async (response) => response.blob(), // Ensure Blob conversion
            }),
            providesTags: ["ShiftRosterImport"],
        }),

        // upload
        dateTypeImport: builder.mutation({
            query: ({ formData }) => {
                return {
                    url: API_ENDPOINTS.SHIFT_ROSTER_IMPORT.DATE_TYPE_IMPORT(),
                    method: "POST",
                    body: formData,
                    responseHandler: async (response) => {
                        if (!response.ok) {
                            const errorData = await response.json();
                            console.log(errorData);
                            return errorData;
                        }
                        return response.blob();
                    },
                };
            },
        }),


        getShiftRosterSample: builder.query({
            query: () => ({
                url: API_ENDPOINTS.SHIFT_ROSTER_IMPORT.GET_SHIFT_ROSTER_SAMPLE(),
                responseHandler: async (response) => response.blob(), // Ensure Blob conversion
            }),
            providesTags: ["ShiftRosterImport"],
        }),

        // upload
        shiftRosterImport: builder.mutation({
            query: ({ formData }) => {
                return {
                    url: API_ENDPOINTS.SHIFT_ROSTER_IMPORT.SHIFT_ROSTER_IMPORT(),
                    method: "POST",
                    body: formData,
                    responseHandler: async (response) => {
                        if (!response.ok) {
                            const errorData = await response.json();
                            console.log(errorData);
                            return errorData;
                        }
                        return response.blob();
                    },
                };
            },
        }),

    }),
});

export const { useGetDateTypeSampleQuery,
    useGetShiftRosterSampleQuery, useShiftRosterImportMutation, useDateTypeImportMutation } = shiftRosterImportListApi;
